import APIService from 'services/APIService'

const api = APIService()

// Public read of a unit's basic info — name + building + address.
// Backed by /api/external-access/qr-landing/units/{unitId}. Throttled.
export const getUnitQrLandingInfo = unitId =>
  api.get(`/external-access/qr-landing/units/${unitId}`)

// Public read of a building's basic info — name + address.
// Backed by /api/external-access/qr-landing/buildings/{bpId}. Throttled.
export const getBuildingQrLandingInfo = bpId =>
  api.get(`/external-access/qr-landing/buildings/${bpId}`)

// Auth'd: resolve a unit id → its parent BP + whether the current user
// already has access. Used to skip the public landing for signed-in
// scanners and route them straight to the auth'd unit detail.
export const resolveUnitForCurrentUser = unitId =>
  api.get(`/me/unit-resolve/${unitId}`)

// Auth'd: SVG/PNG QR for a unit. Used by the BP managers' QR section.
export const downloadUnitQrCode = ({ bpId, unitId, format = 'svg', size = 320 }) =>
  api.get(`/building-passport/${bpId}/units/${unitId}/qr-code`, {
    params: { format, size },
    responseType: 'blob',
  })

// Auth'd: SVG/PNG QR for a building (lobby sticker).
export const downloadBuildingAccessQrCode = ({ bpId, format = 'svg', size = 320 }) =>
  api.get(`/building-passport/${bpId}/access-qr-code`, {
    params: { format, size },
    responseType: 'blob',
  })

// Auth'd: PDF sticker sheet — one QR per unit, A4 portrait, 3×8 grid.
export const downloadUnitQrStickerSheet = bpId =>
  api.get(`/building-passport/${bpId}/units/qr-sticker-sheet`, {
    responseType: 'blob',
  })

// Auth'd: single-unit QR rendered server-side as an A4 PDF.
export const exportUnitQrCodePdf = ({ bpId, unitId }) =>
  api.get(`/building-passport/${bpId}/units/${unitId}/qr-code/export/pdf`, {
    responseType: 'blob',
  })

// Auth'd: building access QR rendered server-side as an A4 PDF.
export const exportBuildingAccessQrCodePdf = ({ bpId }) =>
  api.get(`/building-passport/${bpId}/access-qr-code/export/pdf`, {
    responseType: 'blob',
  })
